import { trigger, state, style, transition, animate } from '@angular/animations';
import { Location } from '@angular/common';
import { Component, ElementRef, ErrorHandler, NgZone, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbCarousel, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Config } from 'src/infrastructure/config';
import { Convertor } from 'src/infrastructure/core/convertor';
import { CoreLabels } from 'src/infrastructure/labels/coreLabels';
import { Errors } from 'src/infrastructure/labels/errors';
import { Pages } from 'src/infrastructure/labels/pages';
import { Successes } from 'src/infrastructure/labels/successes';
import { CategoryAttribute } from 'src/models/DTO/attributes/catAttributes';
import { Favourite } from 'src/models/DTO/favourite/favourite';
import { GroupCollection } from 'src/models/DTO/groups/groupCollection';
import { GroupCollectionItem } from 'src/models/DTO/groups/groupCollectionItem';
import { ImageCollection } from 'src/models/DTO/image/imageCollection';
import { ImageDTO } from 'src/models/DTO/image/imageDTO';
import { UserImageOptions } from 'src/models/DTO/image/userImageOptions';
import { Item } from 'src/models/DTO/items/item';
import { ProductOptionCollection } from 'src/models/DTO/options/productOptionCollection';
import { ProductOption } from 'src/models/DTO/options/productOptions';
import { Partner } from 'src/models/DTO/partners/partner';
import { Price } from 'src/models/DTO/prices/price';
import { ProductTablePricing } from 'src/models/DTO/pricing/productTablePricing';
import { ProductCollection } from 'src/models/DTO/products/productCollection';
import { ProductCollectionItem } from 'src/models/DTO/products/productCollectionItem';
import { Rating } from 'src/models/DTO/ratings/rating';
import { SkuOption } from 'src/models/DTO/skuOptions/SkuOption';
import { UserDTO } from 'src/models/DTO/user/user';
import { Variation } from 'src/models/DTO/variations/variation';
import { VariationOptions } from 'src/models/DTO/variations/variationOptions';
import { AddCartLine } from 'src/models/requestModels/cart/addCartLine';
import { CreateCartRequestModel } from 'src/models/requestModels/cart/createCartModel';
import { createFavouriteRequestModel } from 'src/models/requestModels/favourites/createFavouriteRequestModel';
import { LocalstorageService } from 'src/services/core/localstorage/localstorage.service';
import { ToastService } from 'src/services/core/toast/toast.service';
import { UserService } from 'src/services/core/user/user.service';
import { CartService } from 'src/services/request/cart/cart.service';
import { CategoriesService } from 'src/services/request/categories/categories.service';
import { FavouritesService } from 'src/services/request/favourites/favourites.service';
import { GroupsService } from 'src/services/request/groups/groups.service';
import { ImagesService } from 'src/services/request/images/images.service';
import { ProductService } from 'src/services/request/product/product.service';
import { ProductOptionService } from 'src/services/request/productOptions/product-option.service';
import { ProductsService } from 'src/services/request/products/products.service';
import { RatingsService } from 'src/services/request/ratings/ratings.service';
import { ReviewsService } from 'src/services/request/reviews/reviews.service';
import { UserInfoService } from 'src/services/request/user/userinfo.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';

type SuggestedDeal = {
  pricePerPiece: number;
  qtyFrom: number;
  isPlus: boolean;
};

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css'],
  animations: [
    trigger('slideInOut', [
      state(
        'in',
        style({
          overflow: 'hidden',
          height: '*',
        })
      ),
      state(
        'out',
        style({
          overflow: 'hidden',
          height: '7em',
        })
      ),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out')),
    ]),
  ]
})
export class ProductComponent extends HistoryBaseComponent implements OnInit {

  @ViewChild('carouseltoggleGallery', { static: false })
  carouseltoggleGallery!: NgbCarousel;

  @ViewChild('carouseltoggle')
  carousel!: NgbCarousel;
  posIni: any;

  private colorOptionUUID = 'fbd53375-69ec-4020-aada-93ac88ea3312';
  private sizeOptionUUID = 'af81ba0d-688e-4c7b-9201-779a211ca1b3';

  private _filteredSizes: any[] = [];
  private _selectedColorUUID = '';
  private _selectedSizeUUID = '';
  private _loggedUser?: UserDTO;
  private _item?: Item;
  private _itemImages: ImageCollection = { data: [] };
  private _variationsImages: ImageCollection = { data: [] };
  private _partnerLogoImages: ImageCollection = { data: [] };
  private _selectedItemUUID?: string;
  private _userImagesCollection: { [key: string]: any } = [];
  private _rootCategory = '';
  private _partner?: Partner;
  private _pricing: Price[]  = [];
  private _favourites: Favourite = { data: []};
  private _chosenSize = '';
  private _ratings: Rating = { data: []};
  private _selectedAmount = 1;
  private _productOptions: ProductOptionCollection = { data: [] };
  private _productsForDifferentCategory: ProductCollection = {data: [], meta: { last_page: -1 }};
  private _productsForDifferentCategoryImages: ImageCollection = {data: []};
  private _productsForSameCategory: ProductCollection = {data: [], meta: { last_page: -1 }};
  private _productsForSameCategoryImages: ImageCollection = {data: []};
  public shouldShowBuyDialog = false;
  public isDescrExpanded = false;
  public goToMobileApp = '';
  public clickedImageUUID = '';
  private groups: GroupCollection = { data: [] };
  private groupSecondsLeft = 0;
  private _productGroup?: GroupCollectionItem;
  private _isInGroup?: boolean;
  private readonly productImageCache = new Map<string, string>();

  constructor(
    private imagesService: ImagesService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private ratingsService: RatingsService,
    private productService: ProductService,
    private productsService: ProductsService,
    private productOptionService: ProductOptionService,
    private toast: ToastService,
    private userStateService: LoggedUserService,
    private cartService: CartService,
    private favouriteService: FavouritesService,
    private userService: UserService,
    private modalService: NgbModal,
    protected location: Location,
    private localstorageService: LocalstorageService,
    private userInfoService: UserInfoService,
    private categoriesService: CategoriesService,
    private groupService: GroupsService,
    protected historyService: HistoryService,
    private ngZone: NgZone,
    private reviewService: ReviewsService

  ) {
    super(location, historyService);
    this._pageTitle = 'product';
    this.userStateService.userInfo$.subscribe((user) => {
      this._loggedUser = user;
    });
  }

  ngOnInit(): void {
    this.loadData();
  }

  ngAfterViewInit() {
    this.filterSizes();
  }

  private scrollToTop() {
    window.scrollTo(0, 0);
  }

  private async loadData() {
    if (window.location.href.includes('goToApp')) {
      this.goToMobileApp = 'https://play.google.com/store/apps/details?id=org.nativescript.ShareMeQPay';
    }
    this.activatedRoute.params.subscribe(urlParams => {
      this.clearSuggestedProducts();
      this._rootCategory = urlParams.category;
      this.productService.getProductInfo(urlParams.id).subscribe(response => {
          this._item = response;
          this.getGroups();
          if (this.variations.length) {
           // this.selectItem(this.variations[0].uuid);
          }
          this._item.data.pricing.sort((pricingA, pricingB) => pricingA.quantity_from - pricingB.quantity_from);
          this.getImagesForVariations();
          this.getImagesForItem(this._item);
          this.getProductOptions(this._item);
          this.getImagesForPartner(this._item.data?.organisation.uuid);
          this.getRatingsForItem(this._item);
          if (this.isUserLogged) {
            this.getFavourites();
          }
          if (this._rootCategory == 'none') {
            this.categoriesService.getParentCategory(this._item!.data.category.uuid).subscribe(categories => {
              if (categories.data.length) {
                this.loadSimilarProducts(urlParams, categories.data.pop()!.uuid);
              }
            });
          }
          else {
            this.loadSimilarProducts(urlParams, this._rootCategory);
          }
          this.scrollToTop();
      });
    });
  }

  private loadSimilarProducts(urlParams: any, category: string) {
    this.productsService.getFirstPortionOfProductsPerCategory(Config.defaultItemsPerPage, category).subscribe((response) => {
      response.data.forEach(product => {
        product.pricing.sort((pricingA, pricingB) => pricingA.quantity_from - pricingB.quantity_from);
        product.ratings = { data: []};
        if (product.uuid != urlParams.id) {
          this.getImagesForProduct(product);
          this.getRatingsForProduct(product);
          if (this._item?.data.category.uuid == product.category.uuid) {
            this._productsForSameCategory.data.push(product);
          }
          else {
            this._productsForDifferentCategory.data.push(product);
          }
        }
      });
    });
  }

  private getGroups() {
    this.groupService.getAllGroups().subscribe(groups => {
      this.groups = groups;
      this.startPossibleGroupTime();
    });
  }

  private checkIfProductIsWellSelectedBeforeCart() {
    if (this.colors.length && this._selectedColorUUID && this.sizes.length && this._selectedSizeUUID ) { return true; }
    if (this.colors.length && this._selectedColorUUID && !this.sizes.length) { return true; }
    if (!this.colors.length && this.sizes.length && this._selectedSizeUUID ) { return true; }
    return false;
  }

  private getCurrentsSelectedVariation() {
    if (this._selectedColorUUID && this._selectedSizeUUID) {
      return this.selectVariationOnColorAndSize();
    }
    if (this._selectedColorUUID && !this._selectedSizeUUID) {
      return this.selectVariationOnColor();
    }
    if (!this._selectedColorUUID && this._selectedSizeUUID) {
      return this.selectVariationOnSize();
    }
    else { return null; }
  }

  private selectVariationOnColorAndSize() {
    const availableVariation = this.variations.find(variation => {
      let colored = false;
      let sized = false;
      variation.options.forEach(option => {
        if (option.option.display_name == 'Цвят' && option.value == this._selectedColorUUID){
          colored = true;
        }
        if (option.option.display_name == 'Размер' && option.value == this._selectedSizeUUID){
          sized = true;
        }
      });
      return colored && sized;
    });
    return availableVariation;
  }

  private selectVariationOnColor() {
    const availableVariation = this.variations.find(variation => {
      let colored = false;
      variation.options.forEach(option => {
        if (option.option.display_name == 'Цвят' && option.value == this._selectedColorUUID){
          colored = true;
        }
      });
      return colored;
    });
    return availableVariation;
  }

  private selectVariationOnSize() {
    const availableVariation = this.variations.find(variation => {
      let sized = false;
      variation.options.forEach(option => {
        if (option.option.display_name == 'Размер' && option.value == this._selectedSizeUUID){
          sized = true;
        }
      });
      return sized;
    });
    return availableVariation;
  }

  private clearSuggestedProducts() {
    this._productsForDifferentCategory = {data: [], meta: { last_page: -1 }};
    this._productsForSameCategory = {data: [], meta: { last_page: -1 }};
    this._productsForSameCategoryImages = { data: [] };
    this._productsForDifferentCategoryImages = { data: [] };
  }

  private getImagesForProduct(product: ProductCollectionItem) {
    this.imagesService.getImagesForProduct('PRODUCT', product.uuid).subscribe(image => {
      if (image.data.length) {
        const firstImage = image.data[0];
        firstImage.itemUUID = product.uuid;
        if (this._item?.data.category.uuid == product.category.uuid) {
          this._productsForSameCategoryImages.data.push(firstImage);
        }
        else {
          this._productsForDifferentCategoryImages.data.push(firstImage);
        }
      }
    });
  }

  private getRatingsForProduct(product: ProductCollectionItem) {
    this.ratingsService.getRatingsPerProduct(product.uuid).subscribe(ratings => {
        product.ratings = ratings;
        this.getRatingsAvg(product);
    });
  }

  private getRatingsAvg(product: ProductCollectionItem) {
    let ratingsScore = 0;
    const ratingsCount = product.ratings?.data.length || 0;
    product.ratings?.data.forEach(rating => {
      ratingsScore += rating.rating;
    });
    product.ratingAvgValue = ratingsScore / ratingsCount;
  }

  private getItemRatingsAvg(item: Item) {
    let ratingsScore = 0;
    const ratingsCount = item.data.ratings?.data.length || 0;
    item.data.ratings?.data.forEach(rating => {
      ratingsScore += rating.rating;
    });
    item.data.ratingAvgValue = ratingsScore / ratingsCount;
  }


  private getFavourites() {
    this.favouriteService.getFavourites().subscribe((favourites) => {
      if (favourites) {
        this._favourites = favourites;
      }
      else {
        this._favourites = { data: [] };
      }
    });
  }

  private getImagesForItem(item: Item) {
    this.imagesService.getImagesForProduct('PRODUCT', item.data?.uuid).subscribe(response => {
      this._itemImages = response;
    });
  }

  private getRatingsForItem(item: Item) {
    this.reviewService.getProductReviews(item.data.uuid, 1, 100).subscribe(ratings => {
        item.data.ratings = ratings;
        if (ratings.data.length) {
          this.imagesService.getImagesForProduct('USER', ratings.data[0].user!.uuid, 'logo').subscribe(images => {
            ratings.data[0].user!.userImage = images.data[0].original.url;
          });
        }
        this.getItemRatingsAvg(item);
    });
  }

  private getProductOptions(item: Item) {
    this.productOptionService.getProductOption(item.data.uuid).subscribe(response => {
      this._productOptions = response;
    });
  }

  private getImagesForPartner(partnerUUID: string) {
    this.imagesService.getImagesForProduct('ORGANISATION', partnerUUID, 'logo').subscribe(response => {
      this._partnerLogoImages = response;
    });
  }

  private getImagesForUser(userUUID: string) {
    this.imagesService.getImagesForProduct('USER', userUUID).subscribe(response => {
        this._userImagesCollection[userUUID] = response;
    });
  }

  private getImagesForVariations() {
    this.variations!.forEach(sku => {
      this.imagesService.getImagesForProduct('SKU', sku.uuid).subscribe(response => {
        sku.images = response;
        response.data?.forEach(image => {
            image.itemUUID = sku.uuid;
            this._variationsImages.data?.push(image);
          });
      });
    });
  }


  private returnStockLabel() {
    switch (this._item?.data?.total_available_quantity) {
      case 0:
        return Pages[this._language].shared.notInStock;
      case 1:
        return Pages[this._language].shared.last;
      default:
        return Pages[this._language].shared.inStock;
    }
  }

  private filterSizes(): void {
    this.ngZone.run(() => {
      this._filteredSizes = [];
      const sizes = this._item?.data.skus[2]?.options.find(option => option.option.display_name == 'Размер')?.option.values || [];
      if (!sizes.length) {
        this._item?.data.skus[2]?.options.forEach(option => {
          if (option.option.display_name === 'Размер') {
            sizes.push({
              uuid: option.value,
              value: option.value
            });
          }
        });
      }
      const availableVariations = this.variations.filter(variation => {
        let filtered = false;
        variation.options.forEach(option => {
          if (option.option.display_name === 'Цвят' && option.value === this._selectedColorUUID){
            filtered = true;
          }
        });
        return filtered;
      });
      sizes.forEach(size => {
        availableVariations.forEach(variation => {
          variation.options.forEach(option => {
            if (option.option.display_name === 'Размер' && option.value === size.uuid) {
              this.filteredSizes.push(size);
            }
          });
        });
      });
    });
  }

  private startPossibleGroupTime() {
    this._productGroup = this.groups.data.find(group => group.product.uuid == this._item?.data.uuid);
    if (this._productGroup) {
      this._isInGroup = true;
      setInterval(() => {
        this.compareDates(this._productGroup!.expires_at);
      }, 1000);
    }
    else {
      this._isInGroup = false;
    }
  }

  private compareDates(start: string) {
    const startDate = new Date(start);
    // Do your operations
    const endDate   = new Date().toLocaleString('en-US', {timeZone: 'Europe/Sofia'});
    const seconds = (startDate.getTime() - new Date(endDate).getTime()) / 1000;
    this.groupSecondsLeft = seconds;
  }

  private appendZerosToTime(value: number) {
    if (value < 10) {
      return '0' + value;
    }
    return value.toString();
  }

  get isInGroup() {
    return this._isInGroup;
  }

  get filteredVariations() {
    const availableVariations = this._item?.data.skus.slice(1);
    const returnVariations = this._item?.data.skus.slice(1).filter(vari => false) || [];
    availableVariations?.forEach((variation, index, self) => {
      let status = true;
      const tmpColor = variation.options.find(option => option.option.display_name === 'Цвят')?.value;
      returnVariations.forEach(tmpVar => {
        tmpVar.options.forEach(tmpOpt => {
          if (tmpOpt.option.display_name === 'Цвят' && tmpOpt.value === tmpColor) {
            status = false;
          }
        });
      });
      if (status) {
        returnVariations.push(variation);
      }
    });

    return returnVariations;
  }

  get review() {
    return  this.currentItem?.ratings?.data[0] || null;
  }

  get variations() {
    return this._item?.data.skus.slice(1) || [];
  }

  get isDecreaseButtonDsbld() {
    return this.selectedAmount <= 1;
  }

  get isIncreaseButtonDsbld() {
    if (this._item?.data.total_available_quantity) {
      return this.selectedAmount >= this._item?.data.total_available_quantity;
    }
    else { return true; }
  }

  get inStock() {
    return this._item?.data.total_available_quantity;
  }

  get currentPricing(): Price[] {
    return this._pricing;
  }

  get maxAmountForPricing() {
    return this._item?.data.pricing[this._item?.data.pricing.length - 1].quantity_to.toString() || '';
  }

  get minPriceForPricing() {
    return this._item?.data.pricing[this._item?.data.pricing.length - 1].price_per_piece.toString() || '';
  }

  get groupTime() {
    if (this.groupSecondsLeft) {
      let seconds = Math.ceil(this.groupSecondsLeft);
      // 2- Extract hours:
      const hours = Math.floor( seconds / 3600 ); // 3,600 seconds in 1 hour
      seconds = seconds % 3600; // seconds remaining after extracting hours
      // 3- Extract minutes:
      const minutes = Math.floor( seconds / 60 ); // 60 seconds in 1 minute
      // 4- Keep only seconds not extracted to minutes:
      seconds = seconds % 60;
      return this.appendZerosToTime(hours) + ':' + this.appendZerosToTime(minutes) + ':' + this.appendZerosToTime(seconds);
    }
    else { return ''; }
  }

  get isDescExpandedAnimationString() {
    return (this.isDescrExpanded) ? 'in' : 'out';
  }

  get productOptions(): ProductOptionCollection {
    return this._productOptions;
  }

  get baseProductSpecifications(): Array<{ label: string; value: string }> {
    const item = this.currentItem;

    return [
      { label: 'Марка', value: item?.brand?.name || '-' },
      { label: 'Производител', value: item?.manufacturer?.name || '-' },
      { label: 'Състояние', value: this.getProductConditionLabel(item?.product_condition) },
      { label: 'Код продукт', value: item?.sku || '-' },
      { label: 'Баркод/EAN', value: item?.ean || '-' },
    ];
  }

  private getProductConditionLabel(condition?: string): string {
    if (!condition) {
      return '-';
    }

    if (condition.toLowerCase() === 'new') {
      return 'Ново';
    }

    if (condition.toLowerCase() === 'used') {
      return 'Използвано';
    }

    return condition;
  }

  get delivery() {
    return 'Доставка: ' + this._item?.data.packaging?.delivery_time_in_days + ((this._item?.data.packaging?.delivery_time_in_days == 1) ? ' ден' : ' дни');
  }

  get stockAndDeliveryInfo(): string {
    return this.pageDetails().stock
            + this.returnStockLabel()
            + ' | '
            + this.pageDetails().delivery;
            // + this._item.shipsWithinPeriod
            // + (this._item.shipsWithinPeriod > '1') ? Pages.bg.shared.day : Pages.bg.shared.days;
  }

  get sizeOptions(): string[] {
    return ['S', 'M', 'L', 'XL', '2XL', '3XL'];
  }

  get returnFreeShippongOver() {
    return Pages[this._language].shared.freeDel +  this.currentPartner?.data?.organisations[0]?.data?.free_delivery_after_order_amount + Pages[this._language].shared.currency;
  }

  get currentItem() {
    return this._item?.data;
  }

  get colors(): any {
    const colors =  this._item?.data.skus[1]?.options.find(option => option.option.display_name === 'Цвят')?.option.values || [];
    if (!colors.length) {
      this._item?.data.skus[1]?.options.forEach(option => {
        if (option.option.display_name === 'Цвят') {
          colors.push({
            uuid: option.value,
            value: option.value
          });
        }
      });
    }
    return colors || [];
  }

  get sizes() {
    const sizes = this._item?.data.skus[2]?.options.find(option => option.option.display_name == 'Размер')?.option.values || [];
    if (!sizes.length) {
      this._item?.data.skus[2]?.options.forEach(option => {
        if (option.option.display_name === 'Размер') {
          sizes.push({
            uuid: option.value,
            value: option.value
          });
        }
      });
    }
    const availableSizes: any[] = [];
    sizes.forEach(size => {
      this.variations.forEach(variation => {
        variation.options.forEach(option => {
          if (option.option.display_name === 'Размер' && option.value === size.uuid) {
            availableSizes.push(size);
          }
        });
      });
    });
    return availableSizes;
  }

  get filteredSizes() {
    return this._filteredSizes;
  }

  get productImages(): ImageCollection {
    if (this._selectedItemUUID) {
      return  this.variations.find(variation => variation.uuid == this._selectedItemUUID)?.images || { data: []};
    }
    return this._itemImages.data?.length ? this._itemImages : { data: [ { original: { url: Config.defaultImage} } ]};
  }

  get partnerImageURL()  {
    return (this._partnerLogoImages.data?.length) ? this._partnerLogoImages.data[0].original.url : Config.defaultImage;
  }

  get variationImages()  {
    return this._variationsImages;
  }

  get selectedSizeUUID() {
    return this._selectedSizeUUID;
  }

  get selectedColorUUID() {
    return this._selectedColorUUID;
  }

  get ratings(): Rating {
    return this._ratings;
  }

  get avrgRating(): number {
    if (this._ratings.data?.length) {
      let ratingsSum = 0;
      this._ratings.data?.forEach((rating) => {
        ratingsSum += rating.rating;
      });
      return Number.parseFloat((ratingsSum / this._ratings.data?.length).toFixed(2));
    }
    return 0;
  }

  get isFavourite(): boolean {
    return (this._favourites.data.length > 0) && (this._favourites.data.findIndex(favourite => favourite.uuid  == this._item?.data?.uuid) > -1);
  }

  get ratingsWithComment() {
    return this._ratings.data?.filter((rating) => rating.review);
  }

  get currentPartner(): Partner | undefined {
    return this._partner;
  }


  get selectedAmount(): number {
    return this._selectedAmount;
  }

  get userImages() {
    return this._userImagesCollection;
  }

  get isUserLogged() {
    return this.userService.isUserLogged();
  }

  get productsForCategory() {
    return this._productsForSameCategory;
  }

  get productsForDifferentCategory() {
    return this._productsForDifferentCategory;
  }

  get selectedItemUUID() {
    return this._selectedItemUUID;
  }

  get user() {
    return this._loggedUser;
  }

  get selectedColor(): string {
    if (this._selectedItemUUID) {
      let color = '';
      const variations = this.variations.find(variation => variation.uuid === this._selectedItemUUID);
      const colors = variations?.options.find(option => option.option.display_name === 'Цвят')?.option?.values || '';
      if (!colors.length) {
        color = variations?.options.find(option => option.option.display_name === 'Цвят')?.value || '';
        this._selectedColorUUID = color;
      }
      else {
        const colorUUID = variations?.options.find(option => option.option.display_name === 'Цвят')?.value || '';
        color = this.colors.find( (clr: { uuid: string; }) => clr.uuid === colorUUID)?.value || '';
        this._selectedColorUUID = colorUUID;

      }
      this.filterSizes();
      return color;
    }
    return '';
  }

  userName(review: any) {
    return (review.user?.fist_name || 'Ivan') + ' ' + (review.user?.last_name || 'Grigorov');
  }

  date(review: any) {
    return Convertor.convertDate.pointToDash(review.updated_at);
  }

  public getAttrDataLabel(attribute: ProductOption) {
    if (attribute.type.value == 'boolean') {
      if (attribute.value.value === '1') {
        return 'Да';
      }
      return 'Не';
    }
    return attribute.value.value;
  }

  public selectSize(sizeUUID: string) {
    this._selectedSizeUUID = sizeUUID;
  }

  public getPriceRange(product: ProductCollectionItem) {
    const pricingCounts = product.pricing.length;
    if (!pricingCounts) { return []; }
    const priceArray = product.pricing[0].price_per_piece.split('.');
    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    priceArray.push(CoreLabels.currency[this._language]);
    return priceArray;
  }

  getCardPrice(product: any): number | null {
    const range = this.getPriceRange(product);
    if (!range || !range.length) { return null; }

    const intPart = Number.parseInt(range[0], 10);
    const fracPart = Number.parseInt(range[1] ?? '0', 10);

    if (Number.isNaN(intPart) || Number.isNaN(fracPart)) { return null; }

    const value = Number.parseFloat(`${intPart}.${String(fracPart).padStart(2, '0')}`);
    return Number.isFinite(value) ? value : null;
  }

  getProductImageUrl(uuid: string): string {
    const cached = this.productImageCache.get(uuid);
    if (cached) { return cached; }

    const url = this.productImage(uuid) || '';
    this.productImageCache.set(uuid, url);
    return url;
  }

  public productImage(productUUID: string) {
    const imageURL = this._productsForSameCategoryImages.data.find(image => image.itemUUID == productUUID)?.original.url;
    return (imageURL) ? imageURL : null;
  }

  public differentCategoryProductImage(productUUID: string) {
    const imageURL = this._productsForDifferentCategoryImages.data.find(image => image.itemUUID == productUUID)?.original.url;
    return (imageURL) ? imageURL : null;
  }


  public openItem(productUUID: string) {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
    this.router.navigate(['product/' + productUUID.toString() + '/' + this._rootCategory])
   );
  }

  public getImageURLForVariation(sku: string): string {
    const url = this._variationsImages.data?.find(image => image.itemUUID == sku)?.original.url;
    return (url) ? url : '';
  }

  public checkIfSkuHasColor(sku: any, selectedColorUUID: string) {
    const options = sku.options as SkuOption[];
    const optionValue =  options.find(option => option.option.display_name == 'Цвят')?.value;
    return optionValue == selectedColorUUID;
  }

  public checkIfSkuHasSize(sku: any, selectedColorUUID: string) {
    const options = sku.options as SkuOption[];
    const optionValue =  options.find(option => option.option.display_name == 'Размер')?.value;
    return optionValue == selectedColorUUID;
  }

  move(pos: number, carouselToMove: any) {
    const offset = this.posIni - pos;
    if (offset < -100) {
      carouselToMove.prev();
    }
    if (offset > 100) {
      carouselToMove.next();
    }
  }

  goToGooglePlay(){
    window.location.href = this.goToMobileApp;
  }

  goToReviews() {
    this.router.navigate(['reviews/' + this._item?.data.uuid]);
  }

  registration(currentModal: any) {
    this.localstorageService.setLocalStorageItem(Config.goToRouteLSKey, window.location.href.split(/(?:com|4200)\/(.*)/s)[1]);
    currentModal.close();
    this.router.navigate(['registration']);
  }

  loginNavigation(currentModal: any) {
    this.localstorageService.setLocalStorageItem(Config.goToRouteLSKey, window.location.href.split(/(?:com|4200)\/(.*)/s)[1]);
    currentModal.close();
    this.router.navigate(['login']);
  }


  getAmountLabels(amount: number) {
    return amount + Pages.bg.shared.stock;
  }

  getFullAmountLabel(amount: number) {
    let stock = Pages.bg.shared.fullStocks;
    if (amount == 1) {
      stock = Pages.bg.shared.fullStock;
    }
    return amount + stock;
  }

  getAmountLabel(pricing: ProductTablePricing) {
    let stock = Pages.bg.shared.fullStocks;
    if (pricing.quantity_from == 1) {
      stock = Pages.bg.shared.fullStock;
    }
    if (pricing.quantity_to != pricing.quantity_from) {
      return pricing.quantity_from;
    }
    return pricing.quantity_from + stock;
  }

  getPricingPerAmount(pricing: string) {
    return pricing + Pages.bg.shared.valuePerStock;
  }

  calculateDiscount(pricingFrom: string, pricingTo: string) {
    const pricing = Number.parseFloat(pricingFrom);
    const priceToConvertion = Number.parseFloat(pricingTo);
    const discount = pricing - priceToConvertion;
    return '-' + Math.round((discount / pricing) * 100) + '%';
  }

  deliveryPricingLabel(fee: string | undefined) {
    return fee + Pages.bg.shared.currency;
  }

  chooseSize(size: string) {
    this._chosenSize = size;
  }


  getWarrantyText(warranty: number) {
    if (warranty == 0) {
      return Pages.bg.shared.noWarranty;
    }
    return warranty + Pages.bg.shared.months;
  }

  getCartButtonStyle(numberOfCartLines: number) {
    if (numberOfCartLines < 10) {
      return 'color: white; padding: 1px;background-color: red;border-radius: 20px;height: 22px;width: 22px;padding-left: 7px;position: relative;left: 15px;top: -10px;';
    }
    else {
      return 'color: white; padding: 1px;background-color: red;border-radius: 20px;height: 22px;width: 30px;padding-left: 7px;position: relative;left: 15px;top: -10px;';
    }
  }


  // chooseColor(variation: Variation) {
  //   this._selectedVariation = variation;
  // }


  getActiveClass(type: string, value: any) {
    let classValue = '';
    if (type == 'btn') {
      classValue = 'btn-rounded-lg';
      if (this._chosenSize == value) {
        classValue += ' ative';
      }
    }
    if (type == 'img') {
      classValue = 'btn-rounded-sm';
      // if (this._selectedVariation.id == value.id) {
      //   classValue += " ative";
      // }
    }
    return classValue;
  }

  increaseAmount() {
    if (this._item?.data.total_available_quantity && this.selectedAmount == this._item?.data.total_available_quantity) {
      return;
    }
    this._selectedAmount++;
  }

  decreaseAmount() {
    if (this._selectedAmount == 1) { return; }
    this._selectedAmount--;
  }

  private getSortedPricing(): Array<{ quantity_from: number; price_per_piece: number }> {
    const pricing = (this._item?.data?.pricing ?? this.currentItem?.pricing ?? []) as any[];
    return [...pricing]
      .filter(p => p && p.quantity_from != null && p.price_per_piece != null)
      .map(p => ({
        quantity_from: Number(p.quantity_from),
        price_per_piece: Number(p.price_per_piece),
      }))
      .filter(p => Number.isFinite(p.quantity_from) && Number.isFinite(p.price_per_piece))
      .sort((a, b) => a.quantity_from - b.quantity_from);
  }

  get suggestedDeal(): SuggestedDeal | null {
    const tiers = this.getSortedPricing();
    if (!tiers.length) { return null; }

    const selected = Number(this._selectedAmount ?? this.selectedAmount ?? 1);

    const next = tiers.find(t => t.quantity_from > selected);

    if (next) {
      return {
        pricePerPiece: next.price_per_piece,
        qtyFrom: next.quantity_from,
        isPlus: false,
      };
    }

    const last = tiers[tiers.length - 1];
    return {
      pricePerPiece: last.price_per_piece,
      qtyFrom: last.quantity_from,
      isPlus: true,
    };
  }

  get hasSuggestedDeal(): boolean {
    return !!this.suggestedDeal;
  }

  public variationImageURL(itemUUID: string)  {
    const currentVariationImage = this._variationsImages.data?.find(image => image.itemUUID == itemUUID);
    return (currentVariationImage) ? currentVariationImage.original.url : Config.defaultImage;
  }

  selectItem(uuid: string) {
    this._selectedColorUUID = '';
    this._selectedSizeUUID = '';
    this._selectedItemUUID = uuid;
    this.shouldShowBuyDialog = true;
  }

  share(): void {
    const productId = this.currentItem?.uuid || '';
    const categoryId = this.getShareCategoryId();

    if (!productId || !categoryId) {
      return;
    }

    const title = this.currentItem?.name || 'ShareMe';
    const slug = this.slugify(title);

    const shareUrl = `${window.location.origin}/share/product/${slug}/${productId}/${categoryId}`;

    if (navigator.share) {
      navigator.share({
        title,
        url: shareUrl,
      }).catch(() => {});
      return;
    }

    navigator.clipboard?.writeText(shareUrl).catch(() => {});
  }

  private getShareCategoryId(): string {
    if (this._rootCategory && this._rootCategory !== 'none') {
      return this._rootCategory;
    }

    return this.currentItem?.category?.uuid || '';
  }

  private slugify(value: string): string {
    return (value || 'product')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9а-яё]+/gi, '-')
      .replace(/^-+|-+$/g, '') || 'product';
  }

  private getShareImageUrl(): string {
    const imageUrl = this.productImages.data.length
      ? this.productImages.data[0].original.url
      : Config.defaultImage;

    return this.toAbsoluteUrl(imageUrl);
  }

  private toAbsoluteUrl(url: string): string {
    if (!url) { return ''; }

    if (/^https?:\/\//i.test(url)) {
      return url;
    }

    return `${window.location.origin}${url.charAt(0) === '/' ? '' : '/'}${url}`;
  }

  cart(loginModal: any) {
    if (!this.isUserLogged) {
      this.modalService.open(loginModal, { size: 'sm',  windowClass: 'loginModal' });
      return;
    }
    if (!this.checkIfProductIsWellSelectedBeforeCart() && this.variations.length) {
      this.toast.info('Не сте избрали цвят или размер');
      return;
    }
    this._selectedItemUUID = this.getCurrentsSelectedVariation()?.uuid;
    if (this._loggedUser?.data?.cart) {
      const addCartLine: AddCartLine = {
        cart: this._loggedUser.data?.cart.uuid,
        sku: {
          uuid: this._selectedItemUUID || this._item?.data.skus[0].uuid || '',
          quantity: this.selectedAmount
        }
      };
      const checkForCurrentLine = this._loggedUser.data.cart.lines.find((line) => line.sku.uuid == addCartLine.sku.uuid);
      if (checkForCurrentLine) {
        const selectedSku = this._item?.data.skus.find((sku) => sku.uuid == addCartLine.sku.uuid);
        if (selectedSku && (checkForCurrentLine.quantity + addCartLine.sku.quantity) < selectedSku.available_quantity) {
          this.cartService.updateCartLine(this._loggedUser.data?.cart.uuid, {
            line_uuid: checkForCurrentLine.uuid,
            new_quantity: checkForCurrentLine.quantity + addCartLine.sku.quantity
          }).subscribe(() => {
            this.toast.success(Successes.bg.addToCart);
            this.reloadCart();
          });
        }
        else {
          this.toast.error(Errors.bg.quantityOverflowError);
        }
      }
      else {
        this.cartService.addCartLine(this._loggedUser.data?.cart.uuid, addCartLine).subscribe((response) => {
          this.toast.success(Successes.bg.addToCart);
          this.reloadCart();
        });
      }

    }
    else {
      const createCartModel: CreateCartRequestModel = {
        sku: {
          uuid: this._selectedItemUUID || this._item?.data.skus[0].uuid || '',
          quantity: this.selectedAmount
        }
      };
      this.cartService.createCart(createCartModel).subscribe((response) => {
        this.toast.success(Successes.bg.addToCart);
        this.reloadCart();
      });
    }
  }

  goToCart(loginModal: any) {
    if (!this.isUserLogged) {
      this.modalService.open(loginModal, { size: 'sm',  windowClass: 'loginModal' });
      return;
    }
    this.router.navigate(['order/cart']);
  }

  reloadCart() {
    this.userInfoService.loadUser().subscribe(user => {
      this.userStateService.addNewUser(user);
    });
  }

  getActiveIdForImageCarousel() {
    return this.productImages.data.findIndex(image => image.uuid == this.clickedImageUUID).toString();
  }

  onImageClick(imageModal: any, carouseltoggleGallery: any, image: any) {
    this.clickedImageUUID = image.uuid;
    this.carouseltoggleGallery = carouseltoggleGallery;
    const test = this.modalService.open(imageModal, { size: 'sm',  windowClass: 'imageCaorusel' });
  }

  toggleFavourite(loginModal: any) {
    if (!this.isUserLogged) {
      this.modalService.open(loginModal, { size: 'sm',  windowClass: 'loginModal' });
      return;
    }
    const createFavouriteModel: createFavouriteRequestModel = {
      product_uuid: this._item?.data?.uuid || '',
    };
    if (this.isFavourite) {
      this.favouriteService.removeFavourite(createFavouriteModel).subscribe(() => {
        this.getFavourites();
        this.toast.success(Successes.bg.unfavourite);
      });
    }
    else {
      this.favouriteService.generateFavourite(createFavouriteModel).subscribe(() => {
        this.getFavourites();
        this.toast.success(Successes.bg.favourite);
      });
    }
  }

  goToPartner() {
      this.router.navigate(['partner/' + this._item?.data?.organisation.uuid]);
  }

  seeAllReviews() {
    alert('Navigate to reviews page');
  }

  getPricingFor(qty: number): string {
    if (!this._item) { return '0.00'; }
    let pricing = this._item?.data?.pricing.find((price) => {
      return price.quantity_from <= qty && price.quantity_to >= qty;
    });
    if (this._item) {
      if (!pricing) {
        pricing = this._item!.data.pricing[this._item!.data.pricing.length - 1];
      }
      if (!pricing) {
        pricing = this._item!.data.pricing[0];
      }
    }

    return pricing?.price_per_piece || '0.00';
  }

  unitPriceForSelectedQty(): number {
    return Number.parseFloat(this.getPricingFor(this.selectedAmount) || '0');
  }

  cartTotalPrice(): number {
    return Number.parseFloat(
      (this.unitPriceForSelectedQty() * this.selectedAmount).toFixed(2)
    );
  }

  createGroup(loginModal: any) {
    if (!this.isUserLogged) {
      this.modalService.open(loginModal, { size: 'sm',  windowClass: 'loginModal' });
      return;
    }
    if (!this.checkIfProductIsWellSelectedBeforeCart() && this.variations.length && !this._productGroup) {
      this.toast.info('Не сте избрали цвят или размер');
      return;
    }
    if (this._productGroup) {
      this.router.navigate(['group/' + this._productGroup.uuid]);
    }
    else {
      this.router.navigate(['group/create/' + this._item?.data.uuid + '/' + (this._selectedItemUUID || this._item?.data.skus[0].uuid) + '/' + this.selectedAmount]);
    }
  }

  toFixed(rating: number, toFixed: number) {
    return rating.toFixed(toFixed);
  }
}
